import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsRunDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type GetPartsRunDetailQuery = { __typename?: 'query_root', mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number, status: string, fulfillment_type?: string | null, departure_time?: string | null, parts_delivery?: { __typename?: 'parts_deliveries', id: number, vendor?: string | null, orchestration_status: string, delivery_status: string, fee_cents?: number | null, currency?: string | null, dropoff_eta?: string | null, tracking_url?: string | null, driver?: object | null, proof_of_delivery?: object | null, booked_at?: string | null, completed_at?: string | null, cancelation_reason?: string | null, last_error?: object | null, created_by?: string | null } | null, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, phone?: string | null, avatar_url?: string | null, email?: string | null } | null } | null, scenario?: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, status: string, config: object, offers: Array<{ __typename?: 'offers', id: number, status: string, offered_at?: string | null, offered_by?: string | null, accepted_at?: string | null, accepted_by?: string | null, createdat: string, createdby: string, updatedat: string, updatedby: string, driver: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, phone?: string | null, avatar_url?: string | null, email?: string | null } | null } }> } }> } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, year?: number | null, make: string, model: string, license_plate?: string | null } | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, address?: string | null, address_lat?: number | null, address_lng?: number | null, status: string, notes?: string | null, geofence_arrived_at?: string | null, geofence_departed_at?: string | null, delivery_stop_detail: Array<{ __typename?: 'delivery_stop_details', recipient_business?: string | null, recipient_name?: string | null }>, delivery_orders: Array<{ __typename?: 'delivery_orders', id: number, order_number: string, recipient_business: string, part_number?: string | null, item_description?: string | null, quantity: number, status: string, delivery_status?: string | null, delivered_at?: string | null, pod_signer_name?: string | null, pod_signature_url?: string | null, pod_photo_urls?: object | null, pod_workflow_data: object }> }> } | null };


export const GetPartsRunDetailDocument = gql`
    query getPartsRunDetail($id: bigint!) {
  mobility_runs_by_pk(id: $id) {
    id
    status
    fulfillment_type
    parts_delivery {
      id
      vendor
      orchestration_status
      delivery_status
      fee_cents
      currency
      dropoff_eta
      tracking_url
      driver
      proof_of_delivery
      booked_at
      completed_at
      cancelation_reason
      last_error
      created_by
    }
    departure_time
    driver {
      id
      status
      user {
        id
        display_name
        phone
        avatar_url
        email
      }
    }
    scenario {
      id
      bundletoscenarios(
        order_by: {bundle: {createdat: desc}}
        where: {bundle: {status: {_in: ["ready", "dispatching", "dispatched"]}}}
        limit: 1
      ) {
        bundle {
          id
          status
          config
          offers(
            where: {status: {_in: ["offered", "accepted", "assigned"]}}
            order_by: {createdat: desc}
          ) {
            id
            status
            offered_at
            offered_by
            accepted_at
            accepted_by
            createdat
            createdby
            updatedat
            updatedby
            driver {
              id
              status
              user {
                id
                display_name
                phone
                avatar_url
                email
              }
            }
          }
        }
      }
    }
    vehicle {
      id
      year
      make
      model
      license_plate
    }
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      address
      address_lat
      address_lng
      status
      notes
      geofence_arrived_at
      geofence_departed_at
      delivery_stop_detail {
        recipient_business
        recipient_name
      }
      delivery_orders(order_by: {order_number: asc}) {
        id
        order_number
        recipient_business
        part_number
        item_description
        quantity
        status
        delivery_status
        delivered_at
        pod_signer_name
        pod_signature_url
        pod_photo_urls
        pod_workflow_data
      }
    }
  }
}
    `;

/**
 * __useGetPartsRunDetailQuery__
 *
 * To run a query within a React component, call `useGetPartsRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsRunDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartsRunDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables> & ({ variables: GetPartsRunDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>(GetPartsRunDetailDocument, options);
      }
export function useGetPartsRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>(GetPartsRunDetailDocument, options);
        }
// @ts-ignore
export function useGetPartsRunDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>;
export function useGetPartsRunDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsRunDetailQuery | undefined, GetPartsRunDetailQueryVariables>;
export function useGetPartsRunDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>(GetPartsRunDetailDocument, options);
        }
export type GetPartsRunDetailQueryHookResult = ReturnType<typeof useGetPartsRunDetailQuery>;
export type GetPartsRunDetailLazyQueryHookResult = ReturnType<typeof useGetPartsRunDetailLazyQuery>;
export type GetPartsRunDetailSuspenseQueryHookResult = ReturnType<typeof useGetPartsRunDetailSuspenseQuery>;
export type GetPartsRunDetailQueryResult = Apollo.QueryResult<GetPartsRunDetailQuery, GetPartsRunDetailQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsRunDetail.query.gql}
 */
export async function getPartsRunDetail(
  variables: GetPartsRunDetailQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsRunDetailQuery['mobility_runs_by_pk']>
export async function getPartsRunDetail(
  variables: GetPartsRunDetailQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsRunDetailQuery>
export async function getPartsRunDetail(
  variables: GetPartsRunDetailQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsRunDetailQuery['mobility_runs_by_pk'] | GetPartsRunDetailQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsRunDetailQuery>(
    GetPartsRunDetailDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_runs_by_pk
}